/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountListResponse,
  AccountPaginationResponse,
  BadRequest,
  CreateAccount200Response,
  CreateAccountRequest,
  DuplicateData,
  Forbidden,
  InternalServerError,
  NotFound,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
  UpdateAccountRequest,
  UploadAccountCsv200Response,
} from '../models/index';
import {
    AccountListResponseFromJSON,
    AccountListResponseToJSON,
    AccountPaginationResponseFromJSON,
    AccountPaginationResponseToJSON,
    BadRequestFromJSON,
    BadRequestToJSON,
    CreateAccount200ResponseFromJSON,
    CreateAccount200ResponseToJSON,
    CreateAccountRequestFromJSON,
    CreateAccountRequestToJSON,
    DuplicateDataFromJSON,
    DuplicateDataToJSON,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFoundFromJSON,
    NotFoundToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
    UploadAccountCsv200ResponseFromJSON,
    UploadAccountCsv200ResponseToJSON,
} from '../models/index';

export interface CreateAccountOperationRequest {
    createAccountRequest: CreateAccountRequest;
}

export interface DeleteAccountRequest {
    ifMatch: number;
    accountId: string;
}

export interface ExportAccountCsvRequest {
    sort?: ExportAccountCsvSortEnum;
    role?: number;
    accountNameKeyword?: string;
    emailKeyword?: string;
}

export interface GetAccountsRequest {
    page?: number;
    count?: number;
    sort?: GetAccountsSortEnum;
    status?: number;
    role?: number;
    accountNameKeyword?: string;
    emailKeyword?: string;
    includeOrganization?: boolean;
    includeRelationAllType?: boolean;
}

export interface GetAccountsListRequest {
    accountIds: Array<string>;
    include?: GetAccountsListIncludeEnum;
}

export interface UpdateAccountOperationRequest {
    ifMatch: number;
    accountId: string;
    updateAccountRequest: UpdateAccountRequest;
}

export interface UploadAccountCsvRequest {
    file: Blob;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * 本APIは、アカウント情報を共通認証基盤およびアプリケーションDBに登録します。<br> 登録処理は以下の手順で実行されます。<br><br>  1. 共通認証基盤にユーザーを登録し、初期パスワードを設定します。<br> 2. 登録されたメールアドレス宛にパスワード変更案内メールを送信します。<br> 　- メールにはログインURLおよびパスワード変更手順を記載します。<br> 3. アカウント情報をアプリケーションのDBに保存します。<br> 　- 共通認証基盤での登録に失敗した場合、DBへの登録は行われません。 
     * アカウントの登録
     */
    async createAccountRaw(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAccount200Response>> {
        if (requestParameters['createAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createAccountRequest',
                'Required parameter "createAccountRequest" was null or undefined when calling createAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccountRequestToJSON(requestParameters['createAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、アカウント情報を共通認証基盤およびアプリケーションDBに登録します。<br> 登録処理は以下の手順で実行されます。<br><br>  1. 共通認証基盤にユーザーを登録し、初期パスワードを設定します。<br> 2. 登録されたメールアドレス宛にパスワード変更案内メールを送信します。<br> 　- メールにはログインURLおよびパスワード変更手順を記載します。<br> 3. アカウント情報をアプリケーションのDBに保存します。<br> 　- 共通認証基盤での登録に失敗した場合、DBへの登録は行われません。 
     * アカウントの登録
     */
    async createAccount(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAccount200Response> {
        const response = await this.createAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、指定されたアカウントIDに紐づくユーザーを削除します。<br> アカウント情報は共通認証基盤およびアプリケーションDBの両方に存在するため、<br> 以下の順で削除処理を行います。<br><br>  1. 共通認証基盤から対象ユーザーを削除します。<br> 2. 削除が成功した場合に限り、アプリケーションDBからもアカウント情報を削除します。<br> 　- 共通認証基盤での削除に失敗した場合、DBの情報は削除されません。<br> 3. 対象アカウントが複数の組織に所属している場合は削除できません（エラーとなります）。 
     * アカウントの削除
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAccount200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling deleteAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling deleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/accounts/{account_id}`;
        urlPath = urlPath.replace(`{${"account_id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、指定されたアカウントIDに紐づくユーザーを削除します。<br> アカウント情報は共通認証基盤およびアプリケーションDBの両方に存在するため、<br> 以下の順で削除処理を行います。<br><br>  1. 共通認証基盤から対象ユーザーを削除します。<br> 2. 削除が成功した場合に限り、アプリケーションDBからもアカウント情報を削除します。<br> 　- 共通認証基盤での削除に失敗した場合、DBの情報は削除されません。<br> 3. 対象アカウントが複数の組織に所属している場合は削除できません（エラーとなります）。 
     * アカウントの削除
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAccount200Response> {
        const response = await this.deleteAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、検索条件に一致するアカウント情報をCSV形式でダウンロードします。<br><br>  **CSVファイルのエンコーディングについて**<br> - 本APIが返すCSVファイルは、`Shift_JIS` でエンコードされています。<br>  **Swagger UI からのダウンロード時の注意点**<br> - Swagger UI 経由でCSVファイルをダウンロードした場合、**UTF-8として保存され、文字化けします。**<br> - この場合、curlコマンドなどを使用して直接ファイルをダウンロードしてください。<br><br>  curl 例：<br> <code>curl -o accounts.csv \"http://localhost:8080/order/accounts/csv?sort=desc\" -H \"accept: text/csv\"</code> 
     * アカウント一覧情報CSVのダウンロード
     */
    async exportAccountCsvRaw(requestParameters: ExportAccountCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['accountNameKeyword'] != null) {
            queryParameters['account_name_keyword'] = requestParameters['accountNameKeyword'];
        }

        if (requestParameters['emailKeyword'] != null) {
            queryParameters['email_keyword'] = requestParameters['emailKeyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/accounts/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 本APIは、検索条件に一致するアカウント情報をCSV形式でダウンロードします。<br><br>  **CSVファイルのエンコーディングについて**<br> - 本APIが返すCSVファイルは、`Shift_JIS` でエンコードされています。<br>  **Swagger UI からのダウンロード時の注意点**<br> - Swagger UI 経由でCSVファイルをダウンロードした場合、**UTF-8として保存され、文字化けします。**<br> - この場合、curlコマンドなどを使用して直接ファイルをダウンロードしてください。<br><br>  curl 例：<br> <code>curl -o accounts.csv \"http://localhost:8080/order/accounts/csv?sort=desc\" -H \"accept: text/csv\"</code> 
     * アカウント一覧情報CSVのダウンロード
     */
    async exportAccountCsv(requestParameters: ExportAccountCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportAccountCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アカウント一覧情報取得
     */
    async getAccountsRaw(requestParameters: GetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountPaginationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['accountNameKeyword'] != null) {
            queryParameters['account_name_keyword'] = requestParameters['accountNameKeyword'];
        }

        if (requestParameters['emailKeyword'] != null) {
            queryParameters['email_keyword'] = requestParameters['emailKeyword'];
        }

        if (requestParameters['includeOrganization'] != null) {
            queryParameters['include_organization'] = requestParameters['includeOrganization'];
        }

        if (requestParameters['includeRelationAllType'] != null) {
            queryParameters['include_relation_all_type'] = requestParameters['includeRelationAllType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountPaginationResponseFromJSON(jsonValue));
    }

    /**
     * アカウント一覧情報取得
     */
    async getAccounts(requestParameters: GetAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountPaginationResponse> {
        const response = await this.getAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アカウント一覧情報取得(idリスト指定) payment serviceなど、特定のIDリストに基づいてアカウント情報を取得する場合に使用します。 
     */
    async getAccountsListRaw(requestParameters: GetAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountListResponse>> {
        if (requestParameters['accountIds'] == null) {
            throw new runtime.RequiredError(
                'accountIds',
                'Required parameter "accountIds" was null or undefined when calling getAccountsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountIds'] != null) {
            queryParameters['account_ids'] = requestParameters['accountIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['include'] != null) {
            queryParameters['include'] = requestParameters['include'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/accounts/list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountListResponseFromJSON(jsonValue));
    }

    /**
     * アカウント一覧情報取得(idリスト指定) payment serviceなど、特定のIDリストに基づいてアカウント情報を取得する場合に使用します。 
     */
    async getAccountsList(requestParameters: GetAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountListResponse> {
        const response = await this.getAccountsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、指定されたアカウントIDに紐づくユーザー情報を更新します。<br> アカウント情報は共通認証基盤およびアプリケーションDBの両方に存在しており、<br> 本処理ではそれぞれの情報を整合させるため、以下の手順で処理を行います。<br><br>  1. 共通認証基盤の対象ユーザー情報を更新します（例：メールアドレス、ユーザー名）。<br> 2. アプリケーションDB上のアカウント情報も同期的に更新します。<br> 　- 共通認証基盤での更新に失敗した場合は、DBの更新も行われません。 
     * アカウントの更新
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAccount200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAccountRequest',
                'Required parameter "updateAccountRequest" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/accounts/{account_id}`;
        urlPath = urlPath.replace(`{${"account_id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters['updateAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、指定されたアカウントIDに紐づくユーザー情報を更新します。<br> アカウント情報は共通認証基盤およびアプリケーションDBの両方に存在しており、<br> 本処理ではそれぞれの情報を整合させるため、以下の手順で処理を行います。<br><br>  1. 共通認証基盤の対象ユーザー情報を更新します（例：メールアドレス、ユーザー名）。<br> 2. アプリケーションDB上のアカウント情報も同期的に更新します。<br> 　- 共通認証基盤での更新に失敗した場合は、DBの更新も行われません。 
     * アカウントの更新
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAccount200Response> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、CSV形式で指定された複数のアカウント情報を一括登録します。<br> 各アカウントについて、共通認証基盤およびアプリケーションDBの両方に対して登録処理を行います。<br><br>  1. 各行のアカウント情報に対し、共通認証基盤にユーザーを登録し、初期パスワードを設定します。<br> 2. 登録されたメールアドレス宛に、パスワード変更案内メールを送信します。<br> 　- メールにはログインURLおよびパスワード変更手順を記載します。<br> 3. すべてのアカウント登録（共通認証基盤・DB・メール送信）が成功した場合に限り、登録処理を完了とします。<br> 　- 一部でも失敗した場合は、共通認証基盤およびDBへの登録済みアカウントを全てロールバック（削除）します。<br><br> **注意**： 本APIでは、CSVファイルのエンコーディングとして`Shift_JIS`を使用する必要があります。<br> ファイルが他のエンコーディングで保存されている場合、正しく解析できない可能性があります。 
     * アカウント一覧情報CSVの登録
     */
    async uploadAccountCsvRaw(requestParameters: UploadAccountCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadAccountCsv200Response>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadAccountCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/accounts/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadAccountCsv200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、CSV形式で指定された複数のアカウント情報を一括登録します。<br> 各アカウントについて、共通認証基盤およびアプリケーションDBの両方に対して登録処理を行います。<br><br>  1. 各行のアカウント情報に対し、共通認証基盤にユーザーを登録し、初期パスワードを設定します。<br> 2. 登録されたメールアドレス宛に、パスワード変更案内メールを送信します。<br> 　- メールにはログインURLおよびパスワード変更手順を記載します。<br> 3. すべてのアカウント登録（共通認証基盤・DB・メール送信）が成功した場合に限り、登録処理を完了とします。<br> 　- 一部でも失敗した場合は、共通認証基盤およびDBへの登録済みアカウントを全てロールバック（削除）します。<br><br> **注意**： 本APIでは、CSVファイルのエンコーディングとして`Shift_JIS`を使用する必要があります。<br> ファイルが他のエンコーディングで保存されている場合、正しく解析できない可能性があります。 
     * アカウント一覧情報CSVの登録
     */
    async uploadAccountCsv(requestParameters: UploadAccountCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadAccountCsv200Response> {
        const response = await this.uploadAccountCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ExportAccountCsvSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportAccountCsvSortEnum = typeof ExportAccountCsvSortEnum[keyof typeof ExportAccountCsvSortEnum];
/**
 * @export
 */
export const GetAccountsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAccountsSortEnum = typeof GetAccountsSortEnum[keyof typeof GetAccountsSortEnum];
/**
 * @export
 */
export const GetAccountsListIncludeEnum = {
    All: 'all'
} as const;
export type GetAccountsListIncludeEnum = typeof GetAccountsListIncludeEnum[keyof typeof GetAccountsListIncludeEnum];
